import { DAMO_AUTH_PATHS } from '../../auth-paths';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getParentPath } from '../guard/utils';

const FIREBASE_MODE_MAP: Record<string, string | undefined> = {
  resetPassword: DAMO_AUTH_PATHS.PASSWORD_RESET,
  verifyEmail: DAMO_AUTH_PATHS.VERIFY_EMAIL,
  revertSecondFactorAddition: DAMO_AUTH_PATHS.REVERT_MFA,
};

@Component({
  selector: 'app-action',
  template: '',
})
export class ActionComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    const targetPath = FIREBASE_MODE_MAP[params['mode']];

    if (targetPath) {
      this.router.navigate([`${getParentPath(this.route.snapshot)}/${targetPath}`], { queryParams: params, replaceUrl: true });
    } else {
      this.router.navigate([`${getParentPath(this.route.snapshot)}/${DAMO_AUTH_PATHS.SIGN_IN}`], { replaceUrl: true });
    }
  }
}
